// @ts-nocheck
/* eslint-disable */ /* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */ import { ReactComponent as HexagonADefault } from '../../../../../ui-v3/src/assets/icons/default/shapes/hexagon-a.svg?react';
import { ReactComponent as HexagonASolid } from '../../../../../ui-v3/src/assets/icons/solid/shapes/HEXAGON-A.svg?react';
import { createIcons } from '../../Icon';
const HexagonAIcon = /* @__PURE__ */ createIcons('HexagonA', {
    default: HexagonADefault,
    solid: HexagonASolid
});
HexagonAIcon.supportedTypes = [
    'default',
    'solid'
];
HexagonAIcon.category = 'shapes';
export default HexagonAIcon;
